import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/mt7rk-arrow.svg'


const _hoisted_1 = {
  id: "navul",
  class: "flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Magazine")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "مجلة", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Showcase")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "معرض", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Directory")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "دليل", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { id: "sub-nav" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("About mt7rk ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "عن متحرك", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Contact Us")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "تواصلوا معنا", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Privacy Policy ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "سياسة الخصوصية", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Submit a Tip")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "arabic" }, "شاركونا خبر", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("ul", { id: "socials" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      rel: "noopener",
      href: "https://www.instagram.com/mt7rk.me/"
    }, "Instagram")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      rel: "noopener",
      href: "https://twitter.com/Mt7rkMe"
    }, "Twitter")
  ])
], -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass([_ctx.page])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.goTo('blog')))
          }, _hoisted_5),
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.goTo('awards')))
          }, _hoisted_8),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.goTo('directory')))
          }, _hoisted_11)
        ]),
        _createElementVNode("ul", _hoisted_12, [
          _createElementVNode("li", {
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.goTo('pageView',2)))
          }, _hoisted_15),
          _createElementVNode("li", {
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.goTo('pageView',527)))
          }, _hoisted_18),
          _createElementVNode("li", {
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.goTo('pageView',3)))
          }, _hoisted_21),
          _createElementVNode("li", {
            onClick: _cache[6] || (_cache[6] = $event => (_ctx.goTo('pageView',529)))
          }, _hoisted_24)
        ]),
        _hoisted_25
      ])
    ])
  ], 2))
}